null; /* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fleet-progress-button',
    templateUrl: './progress-button.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgressButtonComponent implements OnInit {
  @Output() actioned = new EventEmitter<any>();
  @Input() color = 'primary';
  @Input() type = 'button';
  @Input() label: string;
  @Input() loading: boolean;
  @Input() actions: { label: string; action: string }[] = [];

  @Input() buttonClass: string;
  //accent for dialog

  @Input() state: any;

  @Input() disabled: boolean;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
